import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { downloadBinaryAsFile } from "@faire/retailer-visitor-shared/lib/downloadBinaryAsFile";
import { logError } from "@faire/web--source/common/logging";
import getMembershipInvoicePdf from "@faire/web-api--source/api/membership/membership-invoice/membershipInvoiceToken/pdf/get";
export var insiderMembershipInvoiceDownload = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(fileName, membershipInvoiceToken) {
        var pdf, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (!membershipInvoiceToken) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        getMembershipInvoicePdf(membershipInvoiceToken)
                    ];
                case 1:
                    pdf = _state.sent();
                    downloadBinaryAsFile(pdf, fileName);
                    _state.label = 2;
                case 2:
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    logError("Could not download membership invoice ".concat(membershipInvoiceToken));
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function insiderMembershipInvoiceDownload(fileName, membershipInvoiceToken) {
        return _ref.apply(this, arguments);
    };
}();
